import React, { useState } from "react";
import Whatsapp from "../../../assets/whtapp.png";

export default function WhatsAppModal({
  whatsappnum,
  setWhatsappnum,
  handleTicket,
  setOpenWhatsappModal,
}) {
  const [error, setError] = useState("");

  const validatePhone = (number) => {
    const regex = /^\d{10}$/; // strictly 10 digits
    return regex.test(number);
  };

  const handleSubmit = () => {
    if (!validatePhone(whatsappnum)) {
      setError("Enter a valid 10-digit mobile number.");
      return;
    }

    setError("");
    handleTicket();
  };

  const handleCancel = () => {
    setWhatsappnum("");
    setError("");
    setOpenWhatsappModal(false);
  };

  const handleNumber = (e) => {
    // remove non-digits + limit to 10
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setWhatsappnum(value);

    if (error) setError("");
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      style={{ padding: "5%",zIndex:99999999 }}
    >
      <div className="bg-white rounded-lg p-6 w-96 shadow-lg relative">
        
        {/* Logo */}
        <div className="flex justify-center -mt-20 mb-4">
          <img
            src={Whatsapp}
            alt="WhatsApp Logo"
            className="w-[102px] h-[102px] rounded-full p-1"
          />
        </div>

        {/* Title */}
        <h2 className="text-center text-lg font-semibold mb-2">
          Enter Your WhatsApp Number
        </h2>

        <p className="text-sm text-gray-600 text-center mb-4">
          We'll use this to raise your support ticket and keep you updated
        </p>

        {/* Input */}
        <input
          type="tel"
          inputMode="numeric"
          placeholder="Please Enter Number"
          value={whatsappnum}
          onChange={handleNumber}
          className={`w-full border ${
            error ? "border-red-500" : "border-gray-300"
          } rounded px-4 py-2 mb-1 focus:outline-none focus:ring-2 focus:ring-green-500`}
        />

        {/* Error */}
        {error && (
          <p className="text-red-500 text-sm mb-2">{error}</p>
        )}

        {/* Buttons */}
        <div className="flex justify-between mt-6">
          <button
            style={{ border: "2px solid #00B177" }}
            onClick={handleCancel}
            className="w-1/2 mr-2 text-green-600 py-2 rounded font-medium hover:bg-green-50 transition"
          >
            Cancel
          </button>

          <button
            style={{ background: "#00B177" }}
            onClick={handleSubmit}
            className="w-1/2 ml-2 text-white py-2 rounded font-medium hover:opacity-90 transition"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
